<!-- eslint-disable vue/no-dupe-keys -->
<template>
    <div>
        <carousel v-if="arrDashboard.length > 0 && isLoaded"
                  id="FlashSaleSlider"
                  :responsive="configCarousel.responsive"
                  :margin="10"
                  :lazyLoad="true"
                  :loop="false"
                  :autoplay="false"
                  :nav="false">
            <div v-for="(v,k) in arrDashboard" :key="k">
                <FlashsaleItemVue
                    :index="k"
                    :lbl="lbl"
                    :campaign="v"
                ></FlashsaleItemVue>
            </div>
        </carousel>
    </div>
</template>
<script>
import Carousel from 'vue-owl-carousel'; // https://github.com/s950329/vue-owl-carousel
import Account from "@/helper/AccountHelper.js";

import FlashsaleItemVue from '@/module/List/component/FlashsaleItem.vue';

/**
 * @property {string} apiConfig (require) Dashboard config_list
 */
export default {
    name: "FlashsaleSlider",
    components: {
        Carousel,
        FlashsaleItemVue
    },
    props: {
        campaigns: Array,
        lbl: Object,
    },
    data: function() {
        return {
            arrDashboard: [],
            configCarousel: {
                responsive: {
                    0: { items: 5.5 },
                },
            },
            isLoaded: false,
            gaugeStyle: {
                width: '0%',
                backgroundColor: "#f8a51b"
            },
            campaign: null,
        };
    },
    created: function() {
        this.blobConfig = Account.getCacheBlob()
        this.arrDashboard = this.campaigns;
        this.isLoaded = true;
    },
    methods: {
    },
}
</script>
<style lang="scss">
@import "@/style/base/base.scss";
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
.campaign-card{
    background-color: #fff;
    border-radius: 8px;

    .campaign-card-img {
        @include baseRatioImg(100%);
        position: relative;
        img {
            border: 0px;
            border-radius: 8px 8px 0 0;
        }
    }

    .campaign-card-info {
        padding: 8px;

        .campaing-name {
            @extend %ellipsis-2;
            font-size: $px16;
            height: 50px;
        }

        .campaing-flashsale-gauge {
            width: 100%;
            margin: auto 0px auto 0px;
            padding: 8px 0 0;
            .flashsale-gauge {
                width: 100%;
                height: 18px;
                background-color: #fef2d9;
                border-radius: 40px;
                overflow: hidden;
                position: relative;
                .gauge-progress {
                    height: 18px;
                    border-radius: 40px;
                }
                .gauge-txt {
                    position: absolute;
                    top: 1px;
                    left: 0;
                    width: 100%;
                    text-align: center;
                    font-size: $px8;
                    color: $a-black-333333;
                }
            }
        }

        .price-card{
            display: flex;
            justify-content: space-between;
            .price-info {
                padding-top: 4px;
                font-family: $ff-medium;
                .price-unit{
                    font-size: $px16;
                    color: $a-red-ff0000;
                }
                .original-price{
                    font-size: $px12;
                    color: $a-gray-999999;
                    text-decoration-line: line-through;
                }
            }
            .add-card {
                flex: none;
                width: 40px;
                margin: auto 0;
                img{
                    width: 100%;
                }
            }
        }
    }
}
</style>
